import { atLeastOneSlotMustBeSelected } from "./TimeslotInput/TimeslotInputState";
import { cannotBeEmptyString, cannotBeHigherThan, cannotBeNullOrUndefined, mustBeValidEmail, unknown, valid } from "./validationUtils";
import { Set } from 'immutable';
export const validateField = (props)=>{
    const validator = buildValidator(props);
    return (field)=>(value)=>{
            const fieldValidators = validator[field];
            let result = unknown;
            for(let i = 0; i < fieldValidators.length; i++){
                result = fieldValidators[i](value);
                if (result.status != 'unknown') break;
            }
            return result.status == "unknown" ? valid : result;
        };
};
const buildValidator = (props)=>({
        firstName: [],
        infix: [],
        lastName: [
            cannotBeEmptyString('Achternaam mag niet ontbreken')
        ],
        companyName: [],
        email: [
            cannotBeEmptyString('E-mailadres mag niet ontbreken'),
            mustBeValidEmail('E-mailadres lijkt niet geldig')
        ],
        phoneNumber: [],
        date: [
            cannotBeNullOrUndefined('Datum mag niet ontbreken')
        ],
        seatplanId: [
            cannotBeNullOrUndefined('Opstelling mag niet ontbreken')
        ],
        participants: [
            cannotBeHigherThan(props.maxParticipants, 'Het aantal deelnemers kan niet groter zijn dan de capaciteit van de gekozen opstelling')
        ],
        timeslots: [
            atLeastOneSlotMustBeSelected('Kies minimaal één dagdeel')
        ],
        means: [],
        note: []
    });
const fast = [
    'participants',
    'timeslots'
];
export const fastFields = Set(fast);
